import { objToUrlParams } from '@/utils'
import request from '@/utils/request'
import exp from 'constants'

// 获取异常的订单列表
export const getExOrderList = (params: any) => request({
    url: '/manage/exception-order-task',
    method: 'get',
    params
})

// 审批异常订单
export const auditExOrder = (data: any) => request({
    url: '/manage/exception-order-task/' + data.task_id,
    method: 'put',
    data
})

// 导出
export const tableExport = (data: any) => request({
    url: '/manage/exception-order-task/export' + objToUrlParams(data),
    method: 'post'
})

// get请求异常订单
export const getAbnormal = (data: any) => request({
    url: '/manage/exception-order-task/' + data.task_id,
    method: 'get',
    data
})

// 批量审批异常订单
export const batchReview = (data: any) => request({
    url: '/manage/change/exception-order-task/status',
    method: 'put',
    data
})

// 获取商户资金明细列表
export const getMerchantFundDetails = (params: any) => request({
    url: '/manage/merchant/' + params.merchant_no + '/transaction',
    method: 'get',
    params
})

// 异常订单批量上分（IMPS 混卡模式）
export const batchBotCarsAction = (data: any) => request({
  url: '/manage/exception-order-task/batch-action',
  method: 'put',
  data
})